import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    tooltip: {},
    icon: {},
}))
